import React from 'react';
import styles from './Footer/footer.module.scss';

const Icon = (props) => {

  const { src } = props;

  return (
      <img src={src} className={styles.icon} />
    );
}

export default Icon;
